import { Controller } from "@hotwired/stimulus";

const EXCLUSIVE_RULES = {
  45: [46, 52], // Você ou pessoas da sua casa são beneficiários de alguma política pública do governo? (marque os benefícios que possui)
  58: [59], // "Com relação a sua casa atual, quais destes você NÃO tem acesso?
};

// <div data-controller="vulnerability-form">
export default class extends Controller {
  connect() {
    this.questionId = this.resolveQuestionId();
    this.exclusiveIds = EXCLUSIVE_RULES[this.questionId] ?? [];

    this.boundHandleChange = this.handleChange.bind(this);

    this.inputs.forEach((input) => {
      input.addEventListener("change", this.boundHandleChange);
    });

    this.toggleNavigationButton();
  }

  disconnect() {
    this.inputs.forEach((input) => {
      input.removeEventListener("change", this.boundHandleChange);
    });
  }

  handleChange(event) {
    if (this.exclusiveIds.length > 0) {
      const changed = event.target;
      const changedId = parseInt(changed.value);
      const isExclusive = this.exclusiveIds.includes(changedId);

      if (changed.checked) {
        if (isExclusive) {
          this.checkboxes.forEach((cb) => {
            if (cb !== changed) cb.checked = false;
          });
        } else {
          this.checkboxes.forEach((cb) => {
            if (this.exclusiveIds.includes(parseInt(cb.value))) {
              cb.checked = false;
            }
          });
        }
      }
    }

    this.toggleNavigationButton();
  }

  toggleNavigationButton() {
    const button = document.getElementById("form-navigation-btn");
    const isDisabled = !this.inputs.some((input) => input.checked);

    if (!button) return;

    button.disabled = isDisabled;
    button.style.pointerEvents = "auto";
    button.style.cursor = isDisabled ? "not-allowed" : "pointer";
  }

  resolveQuestionId() {
    const hidden = this.element.querySelector(
      "input[type='hidden'][name*='question_id']"
    );

    return hidden ? parseInt(hidden.value) : null;
  }

  get checkboxes() {
    return Array.from(this.element.querySelectorAll("input[type='checkbox']"));
  }

  get inputs() {
    return Array.from(
      this.element.querySelectorAll(
        "input[type='checkbox'], input[type='radio']"
      )
    );
  }
}
